import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const BrandShopPage = lazy(
  () =>
    import('./BrandShopPage.eager').then(mod => ({default: mod.BrandShopPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
